import styled from 'styled-components'

export const HiddenFileInput = styled.input.attrs({
  type: 'file',
  value: '',
})`
  display: none;
`
